import api from 'services/api'
import {
  GET_USERS,
  GET_PENDING_USERS,
  DELETE_USER,
  CREATE_USER,
  UPDATE_USER,
  GET_USER_DETAIL,
  UPDATE_USER_STATUS,
  UPDATE_USER_ACCESS,
  BLOCK_UNBLOCK_USER,
  UPDATE_QR_EXPIRY,
} from '../endpoints'

export const getUsers = async (body) => await api.post(GET_USERS, body)
export const getPendingUsers = async (body) => await api.post(GET_PENDING_USERS, body)
export const deleteUser = async (user_id) => await api.delete(DELETE_USER, {data: {user_id}})
export const updateUserStatus = async (body) => await api.post(UPDATE_USER_STATUS, body)
export const toggleUserAccess = async (body) => await api.post(UPDATE_USER_ACCESS, body)
export const blockOrUnblockVendor = async (body) => await api.post(BLOCK_UNBLOCK_USER, body)
export const updateQrCodeExpiry = async (body) => await api.post(UPDATE_QR_EXPIRY, body)

export const submitUser = async (values, user_id) =>
  await api.post(user_id ? UPDATE_USER : CREATE_USER, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const getUserDetail = async (user_id) =>
  await api.get(`${GET_USER_DETAIL}?user_id=${user_id}`)
